import React, { useMemo } from 'react'
import { LayoutBand, Row, Separator, usePageWidth } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import useJumpLinks, { navStyle } from '../../useJumpLinks'
import SectionLink from '../../SectionLink'

export default function JumpLinks({ jumpLinksRef }) {
  const { t } = useTranslation()
  const atPageWidth = usePageWidth()
  const sections = useMemo(
    () => [{ id: 'FamilyTree' }, { id: 'HistoricalDocuments' }, { id: 'GetStarted' }, { id: 'HelpandLearning' }],
    []
  )
  const { activeSectionId } = useJumpLinks({ jumpLinksRef, sections })
  return (
    <LayoutBand marginX="xl" css={navStyle} ref={jumpLinksRef}>
      <Separator size="lg" />
      <Row alignX="center" guttersX={atPageWidth({ md: 'md', xl: 'xxl' })}>
        <SectionLink id={sections[0].id} linkName="Access Family Tree" activeSectionId={activeSectionId}>
          {t('nlihp.united-states.jump-links.access-family-tree', 'Access Family Tree')}
        </SectionLink>
        <SectionLink id={sections[1].id} linkName="Search Historical Documents" activeSectionId={activeSectionId}>
          {t('nlihp.united-states.jump-links.search-historical-documents', 'Search Historical Documents')}
        </SectionLink>
        <SectionLink id={sections[2].id} linkName="Get Started" activeSectionId={activeSectionId}>
          {t('nlihp.united-states.jump-links.get-started', 'Get Started')}
        </SectionLink>
        <SectionLink id={sections[3].id} linkName="Help and Learning" activeSectionId={activeSectionId}>
          {t('nlihp.united-states.jump-links.help-and-learning', 'Help and Learning')}
        </SectionLink>
      </Row>
      <Separator size="lg" />
    </LayoutBand>
  )
}
